const timelines = document.querySelectorAll('.block-timeline');

timelines.forEach((block) => {
    const timeline = block.querySelector('.timeline');
    const line = block.querySelector('.timeline-line');
    const dots = block.querySelectorAll('.timeline-item-dot');

    if (!timeline || !line || !dots.length) return;

    function update() {
        const viewportCenter = window.innerHeight / 2;
        const timelineRect = timeline.getBoundingClientRect();
        const timelineTop = timelineRect.top;
        const timelineHeight = timelineRect.height;

        // Progress: 0 when timeline top hits viewport center, 1 when bottom hits viewport center
        const progress = Math.min(Math.max((viewportCenter - timelineTop) / timelineHeight, 0), 1);
        line.style.setProperty('--timeline-progress', progress);

        // Activate dots when the colored line reaches them
        dots.forEach((dot) => {
            const dotRect = dot.getBoundingClientRect();
            const dotCenter = dotRect.top + dotRect.height / 2;

            if (dotCenter <= viewportCenter) {
                dot.classList.add('is-active');
            } else {
                dot.classList.remove('is-active');
            }
        });
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
});
